// ── revival ───────────────────────────────────────────────────────────────────
// "The Return": a finished show whose cached data now lists a season after the one
// you completed. Pure, so the deck queue, Tonight and the banner all agree.
import { compareProgress } from './episode.js'

export function revivalInfo(show, wlStatus, completedAtIso, progress) {
  if (wlStatus !== 'completed' || !show) return null
  const upcoming = show.next_episode_to_air
  const lastA    = show.last_episode_to_air
  const target   = upcoming || lastA
  if (!target?.season_number) return null

  // "New" means an episode dated AFTER the day you finished (or past your marker
  // when there is no date). A scheduled episode alone is not enough: cached
  // show_data goes stale, and The Boys sat with next_episode_to_air = S5·E7 dated
  // 2026-05-13 on a row finished 05-21, which read as "back" and put S5·E1 on
  // the deck (Jason 2026-10-05).
  const doneDay = completedAtIso ? String(completedAtIso).slice(0, 10) : null
  const beyondMarker = (ep) => (progress?.season ? compareProgress(ep, progress) > 0 : true)
  let isNew = false
  if (upcoming?.air_date) {
    isNew = doneDay ? upcoming.air_date > doneDay : beyondMarker(upcoming)
  } else if (lastA?.air_date && doneDay) {
    isNew = lastA.air_date > doneDay
  } else if (lastA && progress?.season) {
    isNew = compareProgress(lastA, progress) > 0
  }
  if (!isNew) return null

  return { season: target.season_number, airDate: target.air_date || null, upcoming: !!upcoming }
}

// Where a revived show picks back up: the first episode of the returned season
// (what RevivalBanner's Resume lands on), never behind your own marker if you were
// already into that season. null when there is no revival.
export function revivedPosition(show, wlStatus, completedAtIso, progress) {
  const info = revivalInfo(show, wlStatus, completedAtIso, progress)
  if (!info) return null
  const first = { season: info.season, episode: 1 }
  if (progress?.season === info.season && compareProgress(progress, first) > 0) return { season: progress.season, episode: progress.episode }
  return first
}
